<template>
  <v-btn
    :class="[
      'triangle-btn',
      {
        'triangle-btn-active': active,
      },
    ]"
    :loading="loading"
    v-on="$listeners"
    icon
  >
    <vue-icon icon="triangleIcon"></vue-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
    },
    active: {
      type: Boolean,
    },
  },
};
</script>
